// extracted by mini-css-extract-plugin
module.exports = {"cardChapter":"cardChapter_cardChapter__33XBW","title__chapter":"cardChapter_title__chapter__36beN"};